import React from "react";
import styled from 'styled-components';

import { LabeledData } from "./LabeledData";
import { LabeledDataRow } from "./LabeledDataRow";

const StyledBengalBuildBlock = styled.section`
	background: ${(props) => props.theme.colors.neutral1};
	color: ${(props) => props.theme.colors.neutral10};
	scroll-snap-align: start;
`;

const ContentContainer = styled.div`
	box-sizing: border-box;
	padding: 1.75rem 1.5rem;
	max-width: 32rem;
	margin: 0 auto;

	:first-child {
		margin-top: 0;
	}

	${LabeledDataRow} {
		margin-top: 2rem;
	}
`;

const Title = styled.h3`
	${(props) => props.theme.typography.headingL};
	margin-top: 0;
`;

const Build = styled.div``;

export class BengalBuildBlock extends React.Component {

	render() {
		return (
			<StyledBengalBuildBlock>
				<ContentContainer>
					<Title>Suggested starter build</Title>
					<Build>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Flight controller"
								data="JHEMCU GHF722AIO-ICM 40A 2-6S"
								supplemental="A cheap and well made AIO that can easily handle anything the Bengal's motors could ever need, and way more. Later, you could even reuse it in a bigger build."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Video transmitter (digital)"
								data="DJI O4 Air Unit (Lite)"
								supplemental="The best quality VTX in this size, worth the high price. Handle carefully. Use side holes to mount the antenna, so that it doesn't overlap the camera's MIPI cable."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Video transmitter (analog)"
								data="Happymodel OVX300"
								supplemental="A very light VTX, with great value for its price. Extensively tested and widely recommended."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Camera"
								data="Caddx Ant Nano"
								supplemental="A light Nano camera that works well for its price."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Motors"
								data="1103 8000KV motors, or 1204 8000KV motors."
								supplemental="I don't have a specific recommendation."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Propellers"
								data="Gemfan 2520-3"
								supplemental="Delivers great punch for dynamic freestyle. Silent and smooth, with low vibration and acceptable propwash handling."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="Batteries"
								data="Any 3S 550mAh battery"
								supplemental="I don't have a specific recommendation."
							/>
						</LabeledDataRow>
						<LabeledDataRow>
							<LabeledData
								size="s"
								colorContext="dark"
								label="GPS"
								data="BZGNSS BZ-121"
								supplemental="Finds satellites fast. Mount on outside of arm, near the motor, for best results."
							/>
						</LabeledDataRow>
					</Build>
				</ContentContainer>
			</StyledBengalBuildBlock>
		);
	}
}